import moment from 'moment-timezone';

/**
 * Given a JS date, moment date or date-formatted string with the timezone in
 * UTC, convert it to the given user's timezone. The retuned data is a js date.
 *
 * If a fmt string is passed, this will return the date formatted according to
 * that string.
 *
 * @param {(Date | moment | string)?} date
 * @param {{ timezone_id: string? }} user
 * @param {string?} fmt
 * @param {string?} timezoneOverride - Optional timezone to use instead of user's timezone
 * @returns {Date}
 */
export function parseUTC(date, user, fmt, timezoneOverride) {
  if (!date) {
    return null;
  }

  let parsed = moment.utc(date);

  const timezoneId = timezoneOverride || user?.timezone_id;
  if (timezoneId) {
    parsed = parsed.tz(timezoneId);
  } else {
    parsed = parsed.local();
  }

  if (fmt) {
    return parsed.format(fmt);
  }

  // HACK: We have to recreate the moment without any timezone information in
  //       order to prevent toDate from returning the time in local time.
  return moment(
    parsed.format('YYYY-MM-DD HH:mm:ss'),
    'YYYY-MM-DD HH:mm:ss'
  ).toDate();
}
